import { render, staticRenderFns } from "./SecondaryMenuItem.vue?vue&type=template&id=22d821f0&scoped=true"
import script from "./SecondaryMenuItem.vue?vue&type=script&lang=js"
export * from "./SecondaryMenuItem.vue?vue&type=script&lang=js"
import style0 from "./SecondaryMenuItem.vue?vue&type=style&index=0&id=22d821f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d821f0",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SecondaryMenuItem.vue
// module id = 139
// module chunks = 0